import { Box, Button, Flex, Input, useColorModeValue } from '@chakra-ui/react';
import { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';

function DropzoneUploadPhoto(props) {
	const { content, ...rest } = props;

	const onDrop = useCallback(async acceptedFiles => {
		const data = new FormData();
		data.append('file', acceptedFiles[0]);
	}, []);

	const { isDragActive, getRootProps, getInputProps, isDragReject } =
		useDropzone({
			onDrop,
		});

	const bg = useColorModeValue('secondaryGray.300', 'secondaryGray.400');
	const borderColor = useColorModeValue(
		'secondaryGray.400',
		'whiteAlpha.100'
	);
	return (
		<Box>
			<Flex
				align='center'
				justify='center'
				bg={bg}
				border='1px dashed'
				borderColor={borderColor}
				borderRadius='16px'
				w='100%'
				h='max-content'
				minH='100%'
				cursor='pointer'
				{...getRootProps({ className: 'dropzone' })}
				{...rest}
			>
				<Input
					variant='main'
					{...getInputProps()}
				/>
				<Button
					variant='no-effects'
					h={'320'}
				>
					{!isDragActive && content}
					{isDragActive && !isDragReject && 'Solte seu arquivo aqui!'}
				</Button>
			</Flex>
		</Box>
	);
}

export default DropzoneUploadPhoto;
